export const customerServiceView: any = {
	weekday: 'lunes a viernes:',
	weekdayHours: '6:30 a.m. a 4:00 p.m.',
	weekend: 'sábados:',
	weekendHours: '6:30 a.m. a 1:00 p.m.',
	changesInSubscription: 'Para cambios en tu suscripción llama a servicio al cliente al:',
	phoneNumber: '787-641-8800',
	email: 'apoyo@elnuevodia.com',
	customerService: 'Servicio al cliente'
  };
  
  export const subscriptionViewSpanish: any = {
	subscriptionLoggedIn: {
	  title: 'Mi suscripción',
	  subscribeTitle: 'Suscríbete hoy',
	  balance: 'Balance pendiente',
	  credit: 'Crédito',
	  collectionTypeTitle: 'Acuerdo de pago',
	  collectionType: {
		prepaid: 'Pre-pago',
		easyPay: 'Pago Directo',
		carrierCollect: 'Pago al Porteador',
		other: 'Otro'
	  },
	  billCycleTitle: 'Ciclo de pago',
	  deliveryAddress: 'Dirección de entrega'
	},
	subscriptionLoggedOut: {
	  activateTitle: 'Activa tu suscripción',
	  easypayTitle: 'Pago Directo',
	  subscriptionTitle: 'Suscríbete hoy',
	  offerWithoutPromotion: 'Cámbiate hoy a Pago Directo',
	  offerWithPromotion: 'Cámbiate hoy y recibe'
	},
	paymentMethod: {
	  title: 'Información de pago',
	  subtitle: 'Método de pago',
	  changePaymentMethodTitle: 'Cambiar método de pago',
	  choosePaymentMethodTitle: 'Escoge tu método de pago',
	  creditCardTitle: 'Tus tarjetas de crédito',
	  otherPaymentMethodsTitle: 'Otros métodos de pago',
	  chooseBillingAddress: 'Selecciona una dirección de facturación',
	  newCreditCard: {
		addNew: 'Añadir tarjeta de crédito',
		name: 'Nombre en la tarjeta',
		cardNumber: 'Número de tarjeta',
		securityCode: 'Código de Seguridad (CVV)',
		expirationDate: 'Fecha de Expiración',
		month: 'Mes',
		year: 'Año',
		save: 'Guardar tarjeta'
	  },
	  newBankAccount: {
		addNew: 'Añadir cuenta de banco',
		bankAccountName: 'Nombre en la cuenta de banco',
		accountNumber: 'Número de cuenta',
		routingNumber: 'Número de ruta',
		save: 'Guardar cuenta'
	  },
	  action: 'Usar este método de pago'
	},
	deletePaymentMethodModal: {
	  title: 'Eliminar método de pago',
	  body: '¿Estás seguro que deseas eliminar el método de pago seleccionado?'
	},
	paymentHistory: {
	  title: 'Historial de pago',
	  emptyHistoryMessage: 'El historial de pago de tu suscripción no está disponible en estos momentos. Favor llamar a Servicio al Cliente al'
	},
	billingAddress: {
	  title: 'Dirección de facturación',
	  changeBillingAddressTitle: 'Escoge tu dirección de facturación',
	  addressesTitle: 'Tus direcciones',
	  newBillingAddress: {
		addNew: 'Añadir dirección',
		name: 'Nombre',
		lastName: 'Apellido',
		addressLine1: 'Dirección 1',
		addressLine2: 'Dirección 2',
		city: 'Ciudad',
		state: 'Estado / Provincia / Región',
		country: 'País',
		zipcode: 'Código Postal',
		phoneNumber: 'Teléfono de contacto',
		save: 'Guardar dirección'
	  },
	  chooseBillingAddress: 'Usar esta dirección'
	},
	deleteBillingAddressModal: {
	  title: 'Eliminar dirección de facturación',
	  body: '¿Estás seguro que deseas eliminar la dirección de facturación seleccionada?'
	},
	errorModal: {
	  title: 'Cambios en la suscripción',
	  body: 'Los cambios en tu suscripción no pudieron ser procesados. Favor llamar a Servicio al Cliente al 787-641-8800.'
	},
	successChangePaymentMethodModal: {
	  title: 'Método de pago',
	  body: 'Tu método de pago ha sido actualizado.'
	},
	errorDeletePaymentMethodModal: {
	  title: 'Eliminar método de pago',
	  body: 'No es posible eliminar un método de pago que está asociado a una de tus suscripciones. Favor llamar a Servicio al Cliente al 787-641-8800.'
	},
	successChangeBillingAddressModal: {
	  title: 'Dirección de facturación',
	  body: 'Tu dirección de facturación ha sido actualizada.'
	},
	errorDeleteBillingAddressModal: {
	  title: 'Eliminar dirección',
	  body: 'No es posible eliminar una dirección de facturación que está asociada a un método de pago. Favor llamar a Servicio al Cliente al 787-641-8800.'
	},
	errorDeleteLastBillingAddressModal: {
	  title: 'Eliminar dirección',
	  body: "Necesitamos una dirección en el sistema. Si deseas eliminar esta, debes añadir otra. Oprime el enlace 'Añadir una dirección de facturación'."
	},
	errorInTransactionModal: {
	  title: 'Error en la transacción',
	  body: 'La transacción no pudo ser procesada. Favor llamar a Servicio al Cliente al 787-641-8800.'
	},
	activateDigitalAccessModal: {
	  title: 'Activa tu acceso digital',
	  subtitle: 'Provee la siguiente información para encontrar tu suscripción. Completa los campos con la información que utilizaste en tu suscripción.',
	  phoneNumberTitle: 'Teléfono',
	  emailTitle: 'Correo electrónico',
	  requiredFieldsMessage: 'Favor ingresar una de las siguientes combinaciones: Nombre, Apellido, Teléfono y Código postal, ó Nombre, Apellido y Correo electrónico.',
	  successResponse: 'Tu acceso digital ha sido activado exitosamente.',
	  errorResponse: 'Hubo un error activando tu acceso digital. Favor llamar a Servicio al Cliente al 787-641-8800.'
	},
	modalActionButtons: {
	  yes: 'Sí',
	  no: 'No',
	  ok: 'OK',
	  continue: 'Continuar',
	  cancel: 'Cancelar'
	},
	makePaymentModal: {
	  title: 'Hacer un pago',
	  responseTitle: 'Resultado de transacción',
	  confirmPaymentTitle: 'Confirmación de pago',
	  confirmAction: 'Confirmar',
	  offerInformation: 'Información de oferta'
	}
  }
  
  export const changeCollectionTypeView: any = {
	title: 'Pago al Porteador',
	description: 'Cámbiate hoy a Pago Directo',
	easyPayInfo: {
	  title: '¿Qué es Pago Directo?',
	  description: 'Es una manera más fácil de realizar el pago de tu suscripción del periódico impreso y/o Acceso Digital a El Nuevo Día. Esto te permite realizar tus pagos a través de débito automático a tu cuenta bancaria o a una tarjeta de crédito (VISA, Master Card, Discover o AMEX). Para mas información:'
	},
	carrierImportantMessage: 'IMPORTANTE: Recuerda validar con tu porteador hasta qué día tienes pago tu periódico impreso antes de hacer el cambio.',
	action: 'Quiero cambiarme',
	changeCollectionTypeToEasyPay: {
	  title: 'Escoge tu método de pago',
	  creditCardTab: 'Tarjeta de crédito',
	  bankAccountTab: 'Cuenta de banco',
	  easyPayPendingMessage: 'Tu cambio a Pago Directo es efectivo el',
	  termsAndConditionsRequiredMessage: 'Debes aceptar los Términos y Condiciones para continuar.',
	  confirmPage: {
		title: 'Cambiar a Pago Directo',
		action: 'Confirmar'
	  },
	  success: {
		title: 'Gracias',
		body: 'Hemos actualizado en nuestro sistema tu nuevo acuerdo de pago a Pago Directo. Recibirás un correo electrónico con la confirmación.',
		action: 'Volver a Mi Suscripción'
	  },
	  error: {
		title: 'Cambiar a Pago Directo',
		body: 'El cambio en tu suscripción no pudo ser procesado. Puedes intentarlo nuevamente o llamar a Servicio al Cliente al 787-641-8800.',
		action: 'OK'
	  }
	}
  }
  
  export const vacationView: any = {
	showVacation: {
	  title: 'Vacaciones programadas',
	  from: 'Desde el',
	  to: 'hasta el'
	},
	scheduleVacation: {
	  title: 'Programa tus vacaciones',
	  description: 'Podrás agendar tus vacaciones en el periodo de las próximas 4 semanas.',
	  from: 'Desde',
	  to: 'Hasta'
	},
	successSchedulingVacation: {
	  title: 'Programar vacaciones',
	  body: 'Has programado tus vacaciones exitosamente.',
	  action: 'Volver a Mi Suscripción'
	},
	errorSchedulingVacation: {
	  title: 'Programar vacaciones',
	  body: 'Lo sentimos, no pudimos programar tus vacaciones. Para poder agendar vacaciones debes recibir el periódico en ese día seleccionado. (Ejemplo: si recibes el periódico desde jueves, debes marcar el jueves de comienzo hasta el día que desees).',
	  action: 'Volver a Mi Suscripción'
	},
	schedulingExistingVacation: {
	  title: 'Vacaciones existentes',
	  body: 'Las fechas seleccionadas confligen con vacaciones previamente agendadas.',
	  action: 'Volver a Mi Suscripción'
	},
	cancelVacation: {
	  title: 'Cancelar vacaciones',
	  body: '¿Estás seguro que deseas cancelar las vacaciones programadas?'
	},
	successCancelVacation: {
	  title: 'Vacaciones canceladas',
	  body: 'Tus vacaciones han sido canceladas.',
	  action: 'OK'
	},
	errorCancelVacation: {
	  title: 'Vacaciones',
	  body: 'Lo sentimos, no pudimos cancelar tus vacaciones. Por favor intente nuevamente.',
	  action: 'OK'
	}
  }
  


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/subscription.static.data.ts